'use client';

import { createFileRoute, useParams } from '@tanstack/react-router';

import { SupplierProfilePage } from '@/features/suppliers';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/suppliers/$supplierId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.supplierProfile'),
  }),
  component: SupplierProfileRoute,
});

function SupplierProfileRoute() {
  const { supplierId } = useParams({ from: '/_authenticated/suppliers/$supplierId' });
  return <SupplierProfilePage supplierId={supplierId} />;
}
